export default __webpack_public_path__ + "static/media/report-icon.00fb9741.svg";